import FacebookSvg from "@/assets/facebook.svg?react";
import InstagramSvg from "@/assets/instagram.svg?react";
import LinkedinSvg from "@/assets/linkedin.svg?react";
import TiktokSvg from "@/assets/tiktok.svg?react";
import styled from "styled-components";

const Container = styled.footer`
    min-height: 25rem;
    background-color: var(--purple);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5rem;
    gap: 2rem;

    .top {
        display: flex;
        height: 50%;
        width: 100%;
        max-width: 70rem;
        overflow: hidden;
        justify-content: space-between;

        .left {
            display: flex;
            width: fit-content;
            flex-shrink: 1;
            max-height: 6rem;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: left;
            }
        }

        .logos-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 2rem;

            img {
                height: 3.2rem;
            }
        }
    }

    .bottom {
        display: flex;
        width: 100%;
        justify-content: space-between;
        max-width: 70rem;

        ul {
            display: flex;
            flex-direction: column;
            list-style: none;
            flex-grow: 1;

            li {
                a {
                    color: #fff;
                    font-family: Poppins;
                    font-size: 1rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 1.75rem; /* 146.667% */
                    text-decoration: none;
                    color: var(--white);
                }
            }
        }
    }

    a:hover {
        text-decoration: underline !important;
    }
`;

const LinkList = styled.div<{ $screenWidth: number }>`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;
    flex-grow: 1;
    width: 100%;
    margin-top: 30px;

    a {
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
            height: 2rem;
        }
    }
`;

export const BigFooter = () => {
    return (
        <Container>
            <div className="top">
                <div className="left">
                    <img
                        className="logo no-shadow"
                        src="/logos/logo-nav.png"
                    />
                </div>
                <div className="logos-wrapper">
                    <img
                        src="/footer/IAAPA_logo.png"
                        className="no-shadow"
                    />
                    <img
                        src="/footer/adibra_logo.png"
                        className="no-shadow"
                    />
                    <img
                        src="/footer/sidepat_logo.png"
                        className="no-shadow"
                    />
                </div>
            </div>
            <div className="bottom">
                <ul>
                    <li>
                        <a href="/historia">Conheça a vila</a>
                    </li>
                    <li>
                        <a href="/atracoes">Atrações</a>
                    </li>
                    <li>
                        <a href="/festas">Festas</a>
                    </li>
                    <li>
                        <a href="/faq">FAQ</a>
                    </li>
                </ul>
                <ul>
                    <li>
                        <a href="/contato">Contato</a>
                    </li>
                    <li>
                        <a href="/checkout">Ingressos</a>
                    </li>
                    <li>
                        <a href="/atracoes">Mapa da Vila</a>
                    </li>
                    <li>
                        <a href="/trabalhe-conosco">Trabalhe conosco</a>
                    </li>
                </ul>
                <ul>
                    <li>
                        <a href="/escolas">Excursões Escolares</a>
                    </li>
                    <li>
                        <a href="/eventos-corporativos">Eventos Corporativos</a>
                    </li>
                    <li>
                        <a href="/grupos">Grupos</a>
                    </li>
                    <li>
                        <a href="/contato">Parcerias</a>
                    </li>
                    <li>
                        <a href="/politica-de-privacidade">
                            Política de privacidade
                        </a>
                    </li>
                    <li>
                        <a href="/termos-e-condicoes">Termos e Condições</a>
                    </li>
                    <li>
                        <a href="/politica-compra-ingressos">Política de Compra de Ingressos</a>
                    </li>
                </ul>
                <ul>
                    <li>
                        <a href="/regras-e-procedimentos">
                            Regras e Procedimentos
                        </a>
                    </li>
                    <li>
                        <a href="/redes-sociais">Redes Sociais</a>
                    </li>
                    <li>
                        <a href="/ingressos">Qual ingresso comprar</a>
                    </li>
                    <li>
                        <a href="/quiz">Qual smurf eu sou?</a>
                    </li>
                    {/* <li>
                        <a href="/promocao">Regulamentos e promoções</a>
                    </li> */}
                    <LinkList $screenWidth={window.innerWidth}>
                        <a
                            href="https://www.facebook.com/profile.php?id=61586500370528"
                            target="_blank"
                        >
                            <FacebookSvg />
                        </a>
                        <a
                            href="https://www.instagram.com/viladossmurfspark/"
                            target="_blank"
                        >
                            <InstagramSvg />
                        </a>
                        <a
                            href="https://www.linkedin.com/company/viladossmurfspark"
                            target="_blank"
                        >
                            <LinkedinSvg />
                        </a>
                        <a
                            href="https://www.tiktok.com/@viladossmurfspark"
                            target="_blank"
                        >
                            <TiktokSvg />
                        </a>
                    </LinkList>
                </ul>
            </div>
        </Container>
    );
};
